/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {EmailsCheck} from './EmailsCheck';

/**
 * The InlineResponse2014 model module.
 * @module model/InlineResponse2014
 * @version 1.0.0
 */
export class InlineResponse2014 {
  /**
   * Constructs a new <code>InlineResponse2014</code>.
   * @alias module:model/InlineResponse2014
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse2014</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2014} obj Optional instance to populate.
   * @return {module:model/InlineResponse2014} The populated <code>InlineResponse2014</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2014();
      if (data.hasOwnProperty('data'))
        obj.data = EmailsCheck.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EmailsCheck} data
 */
InlineResponse2014.prototype.data = undefined;

